import React from 'react'
import styles from './preview-banner.module.scss'

const PreviewBanner = () => {
    return (
        <div className={styles.PreviewBanner}>
            <span>
                Preview mode
            </span>
        </div>
    )
}

export default PreviewBanner